import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { CommonService } from "../common/common.service";

@Component({
    selector: "app-not-authorized",
    templateUrl: "./not-authorized.component.html",
    styleUrls: ["./not-authorized.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NotAuthorizedComponent implements OnInit {
  constructor(private _commonService: CommonService) {}

  ngOnInit(): void {
    this._commonService
      .activateController([], "Not Authorized")
      .then((response) => response);
  }
}
